/* eslint-disable */
(function () {
  'use strict';

  function numberPdfPages() {
    var holder = {};
    var pageSelectors = ['topage', 'page'];
    var searchResult = document.location.search.substring(1).split('&');
    var index, values, pageElement;

    for (index in searchResult) {
      values = searchResult[index].split('=', 2);
      holder[values[0]] = decodeURIComponent(values[1]);
    }

    for (var selector in pageSelectors) {
      pageElement = document.getElementsByClassName(pageSelectors[selector]);

      for (index = 0; index < pageElement.length; ++index) {
        pageElement[index].textContent = holder[pageSelectors[selector]];
      }
    }
  }

  window.numberPdfPages = numberPdfPages;
})();